export default {
	API_URL: process.env.API_URL || "https://teslacpo.io/api/",
	IMAGE_URL: process.env.IMAGE_URL || "https://teslacpo.io/image.php"
}
